import { createContext } from "react";

export const SalvoContext = createContext();